import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { PhoneNumber } from "@/Common/Models/Contacts/PhoneNumber";
import { Patient } from "@/Common/Models/Patient/Patient";

import styles from "./XcomPatientBanner.module.scss";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IXcomPatientBannerProps {
    patient: Patient;
}

const XcomPatientBanner: React.FC<IXcomPatientBannerProps> = ({ patient }) => {
    const PhonesSection = React.useMemo(() => {
        if (!patient?.Phones?.length) return null;

        return (
            <div className={styles.section}>
                <h5 className={`${styles.h5} uppercase`}>{cacheStore.GetString("XcomTelephoneLable")} </h5>
                {patient.GetPhonesByPriority().map((phone: PhoneNumber, i: number) => (
                    <div className={styles.element} key={i + "__nppl"}>
                        <span className={`${styles.icon} myle-icon-16 phone`} />
                        <div>{phone.format()}</div>
                    </div>
                ))}
            </div>
        );
    }, [patient]);

    const AddressSection = React.useMemo(() => {
        if (!patient?.Addresses?.length) return null;

        return (
            <div className={styles.section}>
                <h5 className={`${styles.h5} uppercase`}>{cacheStore.GetString("AddressLabel")}</h5>
                {patient.Addresses.map((a: Address, i) => (
                    <div className={styles.element} key={i + "__npal"}>
                        <span className={`${styles.icon} myle-icon-16 pin`} />
                        <div>
                            <div>{a.StreetAddress}</div>
                            <div>{a.City}</div>
                            <div>{a.ZipCode}</div>
                        </div>
                    </div>
                ))}

            </div>
        );
    }, [patient]);

    const EmailsSection = React.useMemo(() => {
        if (!patient?.Emails?.length) return null;

        return (
            <div className={styles.section}>
                <h5 className={`${styles.h5} uppercase`}>{cacheStore.GetString("EmailLabel")}</h5>
                {patient.Emails.map((email, i) => (
                    <div className={styles.element} key={i + "__npal"}>
                        <strong className={styles.icon}>@</strong>
                        <div>{email.Address}</div>
                    </div>
                ))}
            </div>
        );
    }, [patient]);

    return (
        <div className={styles.profile}>
            <div className={`${styles.section} ${styles.patient}`}>
                <div className={styles.logo}><img src={img_p_banner_icon_100} alt="MYLE" width="48" /></div>
                <div className={styles.demographics}>
                    <h4 className={`${styles.h4} light-blue`}>{patient.GetFormattedNameWithPrefix()}</h4>
                    <div><strong>{cacheStore.GetString("HealthCard_NAM")}</strong> <span>{patient.GetFormattedNAM()}</span></div>
                    <div><strong>{cacheStore.GetString("DateofBirthLabel")}</strong> <span>{patient.GetFormattedDateOfBirth()} {patient.GetFormattedAge()}</span></div>
                </div>
            </div>

            {PhonesSection}
            {AddressSection}
            {EmailsSection}
        </div>
    );
};

export { XcomPatientBanner };
